<template>
  <div>
    <vs-prompt
      title="Apply email template"
      @cancel="val = ''"
      @accept="accept"
      @close="close"
      :active.sync="prompt"
      accept-text="Apply template"
      :is-valid="validForm"
    >
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-4/5 w-full mb-2">
              <span>
                Select an email template to apply.<br />
                <b>This will override the current email and cannot be undone.</b>
              </span>
            </div>
            <div class="vx-col sm:w-5/5 w-full flex overflow-y-scroll" style="max-height: 60vh">
              <vs-row>
                <vs-col vs-w="6" class="px-2" v-for="template in emailTemplates" :key="template.id">
                  <vs-card
                    :class="{
                      selectedBorder: selectedEmailTemplate && selectedEmailTemplate.id == template.id,
                    }"
                  >
                    <div slot="media">
                      <div class="previewImageWrapper">
                        <img
                          @click.stop.prevent
                          v-img:emailTemplate
                          class="previewImage rounded-lg"
                          :src="template.previewImage"
                        />
                      </div>
                    </div>
                    <div class="w-full flex justify-between items-center">
                      <h4>{{ template.name }}</h4>
                      <vs-button @click="selectedEmailTemplate = template">Select</vs-button>
                    </div>
                  </vs-card>
                </vs-col>
              </vs-row>

              <!-- <vs-select class="w-full" v-model="selectedEmailTemplate">
                <vs-select-item
                  :key="item.id"
                  :value="item.id"
                  :text="item.name"
                  v-for="item in emailTemplates"
                />
              </vs-select> -->
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  data() {
    return {
      name: "",
      prompt: false,
      venueCampaignId: null,

      selectedEmailTemplate: null,
    };
  },
  computed: {
    ...mapGetters({
      emailTemplates: "emailTemplates/emailTemplatesForCampaigns",
    }),
    validForm() {
      return this.selectedEmailTemplate !== null;
    },
  },
  methods: {
    async show(venueCampaignId) {
      this.name = "";
      this.prompt = true;
      this.venueCampaignId = venueCampaignId;

      // await this.$store.dispatch("emailTemplates/getAll");
    },
    async accept() {
      this.$vs.loading();

      const dto = {
        venueCampaignId: this.venueCampaignId,
        emailTemplateId: this.selectedEmailTemplate.id,
      };

      console.log("DTO", dto);

      await this.$store.dispatch("venueCampaigns/applyEmailTemplate", dto);

      this.$vs.loading.close();
    },
    close() {},
  },
};
</script>

<style lang="scss" scoped>
.selectedBorder {
  border: 2px solid black;
}

.previewImageWrapper {
  height: 220px;
  overflow: hidden;
  border-radius: 8px;

  .previewImage {
    transform: scale(1.2) translateY(24px);
    object-fit: cover;
  }
}
</style>
